import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const UserSidebar = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('auth_user'));
  } catch (e) {}

  const navItems = [
    { to: '/user/dashboard', icon: 'fa-house', label: 'Dashboard' },
    { to: '/user/filings', icon: 'fa-file-invoice', label: 'My Filings' },
    { to: '/user/documents', icon: 'fa-folder-open', label: 'Documents' },
    { to: '/user/settings', icon: 'fa-user-gear', label: 'Account Settings' },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        .user-sidebar {
          width: 260px;
          min-width: 260px;
          height: 100vh;
          background: #ffffff;
          color: #1e293b;
          display: flex;
          flex-direction: column;
          position: sticky;
          top: 0;
          left: 0;
          border-right: 1px solid #e8edf3;
          font-family: 'Inter', sans-serif;
          z-index: 100;
          box-shadow: 4px 0 24px rgba(0, 0, 0, 0.02);
        }

        .user-sidebar-header {
          padding: 24px 20px;
          display: flex;
          align-items: center;
          gap: 12px;
          border-bottom: 1px solid #f0f4f8;
        }

        .user-sidebar-logo-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #2563eb, #3b82f6);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          color: white;
          box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
          flex-shrink: 0;
        }

        .user-sidebar-brand {
          display: flex;
          flex-direction: column;
        }

        .user-sidebar-brand-name {
          font-size: 16px;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.4px;
          line-height: 1.2;
        }

        .user-sidebar-brand-sub {
          font-size: 11px;
          color: #94a3b8;
          font-weight: 500;
          letter-spacing: 0.4px;
          text-transform: uppercase;
          margin-top: 2px;
        }

        .user-nav {
          flex: 1;
          padding: 16px 12px;
          display: flex;
          flex-direction: column;
          gap: 2px;
          overflow-y: auto;
        }

        .user-nav-section-label {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 1.2px;
          color: #b0bec5;
          font-weight: 700;
          padding: 10px 10px 4px;
          margin-top: 4px;
        }

        .user-nav-link {
          padding: 10px 12px;
          color: #64748b;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 11px;
          font-weight: 500;
          font-size: 14px;
          border-radius: 10px;
          transition: all 0.18s ease;
          position: relative;
        }

        .user-nav-link:hover {
          background: #f1f5f9;
          color: #0f172a;
        }

        .user-nav-link:hover .nav-icon {
          color: #3b82f6;
        }

        .user-nav-link.active {
          background: #eff6ff;
          color: #1e40af;
          font-weight: 600;
          border: 1px solid #bfdbfe;
        }

        .user-nav-link.active .nav-icon {
          color: #3b82f6;
        }

        .user-nav-link.active::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 55%;
          background: linear-gradient(180deg, #3b82f6, #2563eb);
          border-radius: 0 3px 3px 0;
        }

        .nav-icon {
          width: 18px;
          text-align: center;
          font-size: 14px;
          color: #94a3b8;
          transition: color 0.18s;
          flex-shrink: 0;
        }

        .user-sidebar-divider {
          height: 1px;
          background: #f0f4f8;
          margin: 6px 12px;
        }

        .user-sidebar-footer {
          padding: 14px 12px 20px;
          border-top: 1px solid #f0f4f8;
        }

        .user-user-card {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px;
          border-radius: 12px;
          background: #f8fafc;
          border: 1px solid #e8edf3;
          margin-bottom: 10px;
        }

        .user-user-avatar-sm {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          background: linear-gradient(135deg, #2563eb, #3b82f6);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 14px;
          color: white;
          flex-shrink: 0;
        }

        .user-user-info { flex: 1; min-width: 0; }

        .user-user-name {
          font-size: 13px;
          font-weight: 600;
          color: #0f172a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-user-role {
          font-size: 11px;
          color: #94a3b8;
          margin-top: 1px;
        }

        .logout-btn {
          width: 100%;
          padding: 10px 14px;
          background: #fff5f5;
          border: 1px solid #fecaca;
          color: #ef4444;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.18s ease;
          text-decoration: none;
          font-size: 13px;
          font-weight: 600;
          font-family: 'Inter', sans-serif;
        }

        .logout-btn:hover {
          background: #fee2e2;
          border-color: #fca5a5;
        }

        /* Logout Modal */
        .logout-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.2s ease-out;
        }

        .logout-modal-content {
          background: white;
          padding: 28px 24px;
          border-radius: 16px;
          width: 320px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          text-align: center;
          animation: scaleUp 0.2s ease-out;
        }

        .logout-modal-icon {
          width: 56px; height: 56px; border-radius: 50%;
          background: #fee2e2; color: #ef4444;
          display: flex; align-items: center; justify-content: center;
          font-size: 24px; margin: 0 auto 16px;
        }

        .logout-modal-title { font-size: 18px; font-weight: 700; color: #0f172a; margin: 0 0 8px; }
        .logout-modal-desc { font-size: 14px; color: #64748b; margin: 0 0 24px; line-height: 1.5; }
        .logout-modal-actions { display: flex; gap: 12px; }
        .logout-modal-btn {
          flex: 1; padding: 12px; border-radius: 10px; font-weight: 600; cursor: pointer; border: none; transition: all 0.2s; font-size: 14px;
        }
        .logout-modal-btn-cancel { background: #f1f5f9; color: #475569; }
        .logout-modal-btn-cancel:hover { background: #e2e8f0; }
        .logout-modal-btn-confirm { background: #ef4444; color: white; }
        .logout-modal-btn-confirm:hover { background: #dc2626; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3); }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes scaleUp { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      `}</style>

      <aside className="user-sidebar">
        <div className="user-sidebar-header">
          <img src="/images/logo.png" alt="Logo" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
          <div className="user-sidebar-brand">
            <span className="user-sidebar-brand-name">Legal Infos</span>
            <span className="user-sidebar-brand-sub">Client Portal</span>
          </div>
        </div>

        <nav className="user-nav">
          <div className="user-nav-section-label">Main Menu</div>
          {navItems.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => isActive ? 'user-nav-link active' : 'user-nav-link'}
            >
              <i className={`fa-solid ${icon} nav-icon`}></i>
              {label}
            </NavLink>
          ))}

          <div className="user-sidebar-divider"></div>
          <div className="user-nav-section-label">Support</div>
          <NavLink to="/user/help" className={({ isActive }) => isActive ? 'user-nav-link active' : 'user-nav-link'}>
            <i className="fa-solid fa-circle-question nav-icon"></i>
            Help Center
          </NavLink>
        </nav>

        <div className="user-sidebar-footer">
          <div className="user-user-card">
            <div className="user-user-avatar-sm">{user?.name ? user.name.charAt(0).toUpperCase() : 'U'}</div>
            <div className="user-user-info">
              <div className="user-user-name">{user?.name || 'User'}</div>
              <div className="user-user-role">Client</div>
            </div>
          </div>
          <button onClick={() => setShowLogoutModal(true)} className="logout-btn">
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
            Sign Out
          </button>
        </div>
      </aside>

      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="logout-modal-icon">
              <i className="fa-solid fa-arrow-right-from-bracket"></i>
            </div>
            <h3 className="logout-modal-title">Sign Out</h3>
            <p className="logout-modal-desc">Are you sure you want to sign out of your account?</p>
            <div className="logout-modal-actions">
              <button className="logout-modal-btn logout-modal-btn-cancel" onClick={() => setShowLogoutModal(false)}>
                Cancel
              </button>
              <button 
                className="logout-modal-btn logout-modal-btn-confirm" 
                onClick={() => {
                  localStorage.removeItem('auth_token');
                  localStorage.removeItem('auth_user');
                  navigate('/login');
                }}
              >
                Yes, Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserSidebar;
